import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
//@mui
import { Box } from '@mui/material';
//components
import CostSummary from '../../../components/chancemng/costcalc/CostSummary';
import CostCalcLockList from '../../../components/chancemng/costcalc/CostCalcLockList';
import { useEffect } from 'react';
import { listChanceCosts } from '../../../modules/chanceModule/chanceCosts';

const CostCalcListContainer = () => {
  const dispatch = useDispatch();
  const { chance, costs } = useSelector(({ chanceModule }) => ({
    chance: chanceModule.chance.chance,
    costs: chanceModule.chanceCosts.costs,
  }));

  useEffect(() => {
    if (chance) {
      dispatch(listChanceCosts(chance.prjUuid));
    }
  }, [chance]);

  if (!costs) {
    return null;
  } 

  return (
    <Box>
      <Box
        sx={{
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          py: 1,
        }}
      >
        <CostSummary chance={chance} costsVat={costs}/>
      </Box>
      <Box
        sx={{
          py: 1,
        }}
      >
        <CostCalcLockList costs={costs} />
      </Box>
    </Box>
  );
};

export default CostCalcListContainer;
